export default __webpack_public_path__ + "static/media/img-5.c2759b4f.jpg";